const auth = {
  admin: {
    submit: 'Sign In',
    title: 'Avaca AI Hub',
  },
  common: {
    emailLabel: 'Email Address',
    emailPlaceholder: 'name@company.com',
    hidePassword: 'Hide password',
    loginError: {
      accountUnavailable: 'This account is unavailable. Please contact your administrator.',
      credentialsInvalid: 'Email or password is incorrect. Please try again.',
      emailPasswordDisabled: 'Email and password login is unavailable. Please use SSO.',
      generic: 'Sign-in failed. Please check your information and try again.',
      serviceUnavailable: 'The service is temporarily unavailable. Please try again later.',
    },
    networkError: 'Unable to reach the server. Please try again.',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Please enter the password',
    passwordResetRequired: 'Password reset is required before continuing.',
    showPassword: 'Show password',
    validation: {
      emailInvalid: 'Please enter a valid email',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
    },
  },
  language: {
    ariaLabel: 'Language',
    english: 'EN',
    simplifiedChinese: '中文',
  },
  passwordReset: {
    backToLogin: 'Back to sign in',
    cancelled: 'Current session has been signed out.',
    confirmPassword: 'Confirm new password',
    confirmPasswordPlaceholder: 'Enter the new password again',
    currentPassword: 'Current password',
    currentPasswordPlaceholder: 'Enter current password',
    errors: {
      submitFailed: 'Password update failed. Check your current password and try again.',
    },
    newPassword: 'New password',
    newPasswordPlaceholder: 'Enter new password',
    submit: 'Update password',
    subtitle: 'Update your password before continuing.',
    successLoginPrompt: 'Password updated. Please sign in again with the new password.',
    title: 'Update your password',
    validation: {
      confirmPasswordRequired: 'Confirm the new password',
      currentPasswordRequired: 'Enter current password',
      newPasswordRequired: 'Enter new password',
      passwordMismatch: 'Passwords do not match',
    },
  },
  oauthAuthorization: {
    backToLogin: 'Back to sign in',
    errorDescription: 'The authorization request is invalid or could not restore your Hub session.',
    errorTitle: 'Authorization could not continue',
    processing: 'Continuing authorization...',
  },
  ssoCallback: {
    backToLogin: 'Back to sign in',
    errorDescription: 'Single Sign-On verification failed. Start sign-in again.',
    errorTitle: 'SSO sign-in failed',
    missingCode: 'The sign-in callback is missing required information. Start sign-in again.',
    processing: 'Completing Single Sign-On...',
    success: 'SSO sign-in completed',
  },
  wecomAuth: {
    manualBindingHelp:
      'You can sign in to your existing AI Hub account, then confirm this WeCom identity. Once bound, future workbench visits sign you in without a password.',
    authorizeEmail: 'Authorize work email and link account',
    emailDescription:
      'Authorize your work email to match an existing AI Hub account maintained by your administrator, link it and sign in.',
    restart: 'Open AI Hub again from your WeCom workbench.',
    confirm: 'Confirm binding and continue',
    confirmDescription:
      'Confirm binding the current Portal account to the verified WeCom identity.',
    currentAccount: 'Current Portal account',
    errorTitle: 'WeCom sign-in not completed',
    errors: {
      configurationIncomplete:
        'Automatic WeCom binding is not configured. Ask your administrator to complete the email binding settings.',
      authorizationIncomplete: 'Authorization is incomplete. Please authorize again.',
      emailMissing:
        'Email was unavailable. Ask your administrator to check app permissions and your directory profile.',
      emailNotAllowed: 'This email is outside the permitted domains. Contact your administrator.',
      accountNotFound:
        'No AI Hub account matches your WeCom email. Ask your administrator to create an account or correct its email in Organization management.',
      accountEmailAmbiguous:
        'Multiple AI Hub accounts have this email. Ask your administrator to resolve the duplicate before trying again.',
      notEligible:
        'The sign-in flow has changed. Close this page and reopen AI Hub from your WeCom workbench.',
      emailChanged:
        'Your AI Hub email changed during sign-in. Reopen the app from the workbench. If it still fails, ask your administrator to check both email addresses.',
      requiresReset: 'Your account requires a password reset. Contact your administrator first.',
      identityMismatch:
        'The WeCom accounts used for the two authorizations differ. Start again from the workbench.',
      policyChanged: 'Authentication settings changed. Start again from the workbench.',
      versionConflict: 'Authorization state changed. Please retry.',
      accountInactive: 'This account is unavailable. Contact your administrator.',
      bindingNotReady: 'The WeCom connection is unavailable. Contact your administrator.',
      conflict: 'This WeCom identity is bound to another account. Contact your administrator.',
      expired: 'This sign-in has expired. Try again from the Workbench.',
      generic: 'WeCom sign-in was not completed. Please try again.',
      unavailable: 'WeCom is temporarily unavailable. Please try again later.',
      unbound: 'Sign in to a Portal account once to complete binding.',
    },
    goToLogin: 'Go to sign in',
    processing: 'Completing WeCom sign-in...',
    signedInAccount: 'Current signed-in account',
  },
  user: {
    divider: 'Or continue with',
    noLoginMethods: 'No sign-in method is available. Contact your administrator.',
    redirectingToSso: 'Redirecting to enterprise sign-in...',
    sso: 'Single Sign-On (SSO)',
    submit: 'Log In',
    title: 'Avaca AI Hub',
  },
}

export default auth
